module.exports = __webpack_public_path__ + "static/media/googleAssistant.0c8a4c11.jpg";